export function fetchCoverLetterContent(content) {
  return {
    type: "FETCH_COVER_LETTER_CONTENT",
    payload: content
  }
}
